// extracted by mini-css-extract-plugin
module.exports = {"whole-home-A":"A_whole-home-A__C_inG"};